import { UnstyledButton } from '@src/components/base/Buttons'
import ArrowBase from '@src/components/Tooltip/Arrow'
import sunkist from '@src/styled/theme'
import styled from 'styled-components'

export const Border = styled(UnstyledButton)`
  text-align: start;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.greyLight};
  border-radius: 4px;
  box-shadow: 0 -2px 16px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  position: relative;
  width: 162px;
`

export const Text = styled.div`
  padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.sm}`};
  color: ${({ theme }) => theme.colors.dark};
  text-decoration: underline;
  text-decoration-color: ${({ theme }) => theme.colors.dark};
  font-size: ${({ theme }) => theme.font.text.size.sm};
`

const AbsoluteArrow = styled(ArrowBase)`
  position: absolute;
`

export const Arrow = styled(AbsoluteArrow).attrs({
  color: sunkist.colors.white,
  size: sunkist.spacing.sm,
})`
  left: ${({ theme }) => theme.spacing.md};
  ${({ point }) => (point === 'up' ? 'top: -10px;' : '')}
`

/*  https://stackoverflow.com/questions/9450733/css-triangle-custom-border-color */
/*  add a triangle border color */
export const BorderArrow = styled(AbsoluteArrow).attrs({
  color: sunkist.colors.greyLight,
  size: '11px',
})`
  left: 19px;
  ${({ point }) => (point === 'up' ? 'top: -11px;' : '')}
  border-width: 11px;
`



// WEBPACK FOOTER //
// ./src/layouts/shared/Recheck/Tooltip/styles.ts